export const ELEMENT_INDEX_KEY = 'ElementIndex';
export const ELEMENT_KEY = 'Element';
export const PREV_ELEMENT_INDEX_KEY = 'PrevElementIndex';
export const PREV_ELEMENT_KEY = 'PrevElement';
export const EMPLOYEE_ID_KEY = 'EmployeeId';
export const ERROR_MESSAGE_KEY = 'ErrorMessage';
export const EVENT_TYPE_KEY = 'EventType';
export const SCREEN_NAME_KEY = 'ScreenName';
export const SCREEN_TYPE_KEY = 'ScreenType';
export const SCREEN_URI = 'ScreenUri';
//# sourceMappingURL=AttributeKeys.js.map